import React, { useState } from "react";
import { AiOutlineDownload } from "react-icons/ai";
import { apiPostPut } from "../../api/api_methods";
import { IoIosCloseCircleOutline } from "react-icons/io";
// import { apiPostPut } from "../../services/api";

const ExportResumes = ({ onClose, jdId }) => {
  const [resumeType, setResumeType] = useState("All resumes");
  const [dateRange, setDateRange] = useState("all");
  const [scoreRange, setScoreRange] = useState("");
  const [experienceRange, setExperienceRange] = useState("all");
  // const [startDate, setStartDate] = useState("null");
  // const [endDate, setEndDate] = useState("currentDate");
  const [minScore, setMinScore] = useState();
  const [maxScore, setMaxScore] = useState();
  const [minExperience, setMinExperience] = useState("");
  const [maxExperience, setMaxExperience] = useState("");
  const [exportFormat, setExportFormat] = useState("Xls");
  const [isCustomDate, setIsCustomDate] = useState(true);
  const currentDate = new Date().getTime();
  const [isCustomScore, setIsCustomScore] = useState(true);

  const [currentTab, setCurrentTab] = useState(-1);
  const [selectedExport, setSelectedExport] = useState();
  const [resumesData, setResumesData] = useState();
  const ExportFormat = [
    { name: "Pdf", action: () => setCurrentTab(0), id: 0 },
    { name: "Xls", action: () => setCurrentTab(1), id: 1 },
    { name: "Csv", action: () => setCurrentTab(2), id: 2 },
    { name: "Json", action: () => setCurrentTab(3), id: 3 },
  ];

  console.log(exportFormat);

  // const handleDateRangeChange = (e) => {
  //   const value = e.target.value;

  //   if (value === "custom") {
  //     setIsCustomDate(true);
  //   } else if (value === "lastWeek") {
  //     // getting the date of last week
  //     const lastWeek = currentDate - 7 * 24 * 60 * 60 * 1000;
  //     setStartDate(lastWeek);
  //     setEndDate(currentDate);
  //     setIsCustomDate(false);
  //   } else if (value === "last15Days") {
  //     // getting the date of last 15 days
  //     const last15Days = currentDate - 15 * 24 * 60 * 60 * 1000;
  //     setStartDate(last15Days);
  //     setEndDate(currentDate);
  //     setIsCustomDate(false);
  //   } else if (value === "last30Days") {
  //     // getting the date of last 30 days
  //     const last30Days = currentDate - 30 * 24 * 60 * 60 * 1000;
  //     setStartDate(last30Days);
  //     setEndDate(currentDate);
  //     setIsCustomDate(false);
  //   } else {
  //     setStartDate(null);
  //     setEndDate(currentDate);
  //     setIsCustomDate(false);
  //   }
  // };

  const handleScoreRangeChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustomScore(true);
    } else {
      setIsCustomScore(false);
    }
  };

  const handleExport = async () => {
    const payload = {
      minScore,
      maxScore,
      minExperience,
      maxExperience,
      // startDate,
      // endDate,
    };
    //   on export payload

    console.log(payload);
    console.log("this is the view", selectedExport);

    const response = await apiPostPut(
      payload,
      `/jds/resumes-data/${jdId}`,
      "POST"
    );

    // filter according to the payload and export the data

    //add a condition to check if the response is empty
    if (response.body.resumesData.length === 0) {
      alert("No resumes found for the selected criteria");
      return;
    }

    setResumesData(response.body.resumesData);
    if (exportFormat === "Xls") {
      exportToExcel(response.body.resumesData);
      alert("Resumes have been exported as an Excel file.");
    } else if (exportFormat === "Csv") {
      exportToCsv(response.body.resumesData);
      alert("Resumes have been exported as a CSV file.");
    } else if (exportFormat === "Json") {
      exportToJson(response.body.resumesData);
      alert("Resumes have been exported as a JSON file.");
    } else {
      alert("PDF export is coming soon...");
    }
    // exportToPDF(response.body.resumesData);

    console.log(response.body.resumesData);
  };

  const exportToPDF = (response) => {
    if (!Array.isArray(response)) {
      console.error("Response is not an array or is undefined.");
      return;
    }
    // convert the csv file to pdf
    const headers = new Set();
    response.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (Array.isArray(item[key])) {
          // Add keys for nested arrays
          headers.add(key);
        } else {
          headers.add(key);
        }
      });
    });

    // Convert headers to an array and prepare the CSV header row
    const headerArray = Array.from(headers);
    let CsvString = headerArray.join(",") + "\n";

    // Process each object in the response
    response.forEach((item) => {
      const row = headerArray.map((header) => {
        const value = item[header];

        if (Array.isArray(value)) {
          // Handle nested arrays (e.g., skills, projects)
          if (header === "skills") {
            return value.map((skill) => skill.skill).join("; ");
          } else if (header === "projects") {
            return value
              .map(
                (project) =>
                  `${project.title} (${project.techStackUsed.join(", ")})`
              )
              .join("; ");
          } else if (header === "match") {
            return value
              .map(
                (match) =>
                  `Score: ${match.score}, Suggestion: ${match.suggestion}`
              )
              .join("; ");
          } else {
            return value.join("; "); // Generic handling for other arrays
          }
        } else if (value && typeof value === "object") {
          // Handle nested objects
          return JSON.stringify(value);
        } else {
          // Handle primitive values
          return value !== undefined && value !== null ? `"${value}"` : "";
        }
      });

      CsvString += row.join(",") + "\n";
    });

    // Create a downloadable csv to pdf file
    const encodedUri =
      "data:text/csv;charset=utf-8," + encodeURIComponent(CsvString);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "resumes.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after download
  };

  const exportToJson = (response) => {
    if (!Array.isArray(response)) {
      console.error("Response is not an array or is undefined.");
      return;
    }
    const jsonString = JSON.stringify(response, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "resumes.json";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after download
  };

  const exportToCsv = (response) => {
    if (!Array.isArray(response)) {
      console.error("Response is not an array or is undefined.");
      return;
    }

    // Extract all unique keys from the objects (including nested keys)
    const headers = new Set();
    response.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (Array.isArray(item[key])) {
          // Add keys for nested arrays
          headers.add(key);
        } else {
          headers.add(key);
        }
      });
    });

    // Convert headers to an array and prepare the CSV header row
    const headerArray = Array.from(headers);
    let CsvString = headerArray.join(",") + "\n";

    // Process each object in the response
    response.forEach((item) => {
      const row = headerArray.map((header) => {
        const value = item[header];

        if (Array.isArray(value)) {
          // Handle nested arrays (e.g., skills, projects)
          if (header === "skills") {
            return value.map((skill) => skill.skill).join("; ");
          } else if (header === "projects") {
            return value
              .map(
                (project) =>
                  `${project.title} (${project.techStackUsed.join(", ")})`
              )
              .join("; ");
          } else if (header === "match") {
            return value
              .map(
                (match) =>
                  `Score: ${match.score}, Suggestion: ${match.suggestion}`
              )
              .join("; ");
          } else {
            return value.join("; "); // Generic handling for other arrays
          }
        } else if (value && typeof value === "object") {
          // Handle nested objects
          return JSON.stringify(value);
        } else {
          // Handle primitive values
          return value !== undefined && value !== null ? `"${value}"` : "";
        }
      });

      CsvString += row.join(",") + "\n";
    });

    // Create a downloadable CSV file
    const encodedUri =
      "data:text/csv;charset=utf-8," + encodeURIComponent(CsvString);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "resumes.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after download
  };

  const exportToExcel = (response) => {
    if (!Array.isArray(response)) {
      console.error("Response is not an array or is undefined.");
      return;
    }

    // Prepare the Excel XML header
    let excelFile = `
            <?xml version="1.0"?>
            <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
                      xmlns:o="urn:schemas-microsoft-com:office:office"
                      xmlns:x="urn:schemas-microsoft-com:office:excel"
                      xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
              <Worksheet ss:Name="Resumes">
                <Table>
        `;

    // Add headers dynamically based on all keys in the first object
    const headers = Object.keys(response[0]);
    excelFile += "<Row>";
    headers.forEach((header) => {
      excelFile += `<Cell><Data ss:Type="String">${header}</Data></Cell>`;
    });
    excelFile += "</Row>";

    // Add data rows
    response.forEach((item) => {
      excelFile += "<Row>";
      headers.forEach((header) => {
        let value = item[header];

        if (Array.isArray(value)) {
          // Handle arrays (e.g., skills, projects)
          if (header === "skills") {
            value = value.map((skill) => skill.skill).join("; ");
          } else if (header === "projects") {
            value = value
              .map(
                (project) =>
                  `${project.title} (${project.techStackUsed.join(", ")})`
              )
              .join("; ");
          } else if (header === "match") {
            value = value
              .map(
                (match) =>
                  `Score: ${match.score}, Suggestion: ${match.suggestion}`
              )
              .join("; ");
          } else {
            value = value.join("; "); // Generic handling for other arrays
          }
        } else if (value && typeof value === "object") {
          // Handle objects
          value = JSON.stringify(value);
        }

        // Ensure null or undefined values are empty strings
        value = value !== undefined && value !== null ? value : "";

        excelFile += `<Cell><Data ss:Type="String">${value}</Data></Cell>`;
      });
      excelFile += "</Row>";
    });

    // Close the XML tags
    excelFile += `
                </Table>
              </Worksheet>
            </Workbook>
        `;

    // Create a downloadable file
    const blob = new Blob([excelFile], { type: "application/vnd.ms-excel" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "resumes.xls";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after download
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black backdrop-blur-sm bg-opacity-50">
      <form
        className="bg-white p-8 rounded-lg shadow-lg w-[93%]  max-w-3xl"
        onSubmit={(e) => {
          e.preventDefault(); // Prevent default form submission

          if (scoreRange === "custom" && (minScore === "" || maxScore === "")) {
            alert("Please enter the score range");
            return;
          }

          if (
            experienceRange === "custom" &&
            (minExperience === "" || maxExperience === "")
          ) {
            alert("Please enter the experience range");
            return;
          }

          handleExport();
          onClose();
        }}
      >
        {/* Header */}
        <div className="flex items-center mb-6 relative">
          <button
            type="button"
            className="absolute text-primary -top-6 -right-6"
            onClick={onClose}
          >
            <IoIosCloseCircleOutline size={24} />
          </button>
          <div className="w-10 h-10 bg-primary2 rounded-full flex items-center justify-center mr-4">
            <AiOutlineDownload size={22} />
          </div>
          <h2 className="text-xl font-semibold text-gray-800">
            Export Resumes
          </h2>
        </div>

        {/* Form */}
        <div className="space-y-6">
          {/* Date Range and Score Range */}
          <div className="flex space-x-4">
            {/* Score Range */}
            <div className="w-1/2">
              <label className="block text-sm font-semibold text-black">
                Score Range
              </label>
              <div className="mt-1">
                <select
                  className="block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                  required
                  value={scoreRange}
                  onChange={(e) => {
                    setScoreRange(e.target.value);

                    if (e.target.value === "custom") {
                      setIsCustomScore(true);
                      setMinScore("");
                      setMaxScore("");
                    } else {
                      setIsCustomScore(false);
                      if (e.target.value === "all") {
                        setMinScore("0");
                        setMaxScore("100");
                      }
                      if (e.target.value === "above 90") {
                        setMinScore("90");
                        setMaxScore("100");
                      }
                      if (e.target.value === "70-89") {
                        setMinScore("70");
                        setMaxScore("89");
                      }
                      if (e.target.value === "less than 70") {
                        setMinScore("0");
                        setMaxScore("69");
                      }
                    }
                  }}
                >
                  <option value="">Select Option</option>
                  <option value="all">All scores</option>
                  <option value="above 90">Above 90%</option>
                  <option value="70-89">70%-89%</option>
                  <option value="less than 70">Less than 70%</option>
                  <option value="custom">Custom score</option>
                </select>
                {scoreRange === "custom" && (
                  <div className="flex space-x-2 mt-2">
                    <input
                      type="number"
                      className="block w-1/2 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                      value={minScore}
                      onChange={(e) => setMinScore(e.target.value)}
                      placeholder="Min score"
                      required
                    />
                    <input
                      type="number"
                      className="block w-1/2 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                      value={maxScore}
                      onChange={(e) => setMaxScore(e.target.value)}
                      placeholder="Max score"
                      required
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Experience Range */}
            <div className="w-1/2">
              <label className="block text-sm font-semibold text-black">
                Experience Range
              </label>
              <div className="mt-1">
                <select
                  className="block w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                  required
                  value={experienceRange}
                  onChange={(e) => {
                    setExperienceRange(e.target.value);

                    if (e.target.value === "custom") {
                      setIsCustomScore(true);
                      setMinExperience("");
                      setMaxExperience("");
                    } else {
                      setIsCustomScore(false);
                      if (e.target.value === "all") {
                        setMinExperience("");
                        setMaxExperience("");
                      }
                      if (e.target.value === "1-2") {
                        setMinExperience("1");
                        setMaxExperience("2");
                      }
                      if (e.target.value === "2-5") {
                        setMinExperience("2");
                        setMaxExperience("5");
                      }
                      if (e.target.value === "5-10") {
                        setMinExperience("5");
                        setMaxExperience("10");
                      }
                    }
                  }}
                >
                  <option value="">Select Experience</option>
                  <option value="all">All experience levels</option>
                  <option value="1-2">1-2 years</option>
                  <option value="2-5">2-5 years</option>
                  <option value="5-10">5-10 years</option>
                  <option value="custom">Custom experience</option>
                </select>
                {experienceRange === "custom" && (
                  <div className="flex space-x-2 mt-2">
                    <input
                      type="number"
                      className="block w-1/2 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                      value={minExperience}
                      onChange={(e) => setMinExperience(e.target.value)}
                      placeholder="Min experience"
                      required
                    />
                    <input
                      type="number"
                      className="block w-1/2 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500"
                      value={maxExperience}
                      onChange={(e) => setMaxExperience(e.target.value)}
                      placeholder="Max experience"
                      required
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Export Format */}
          <div>
            <label className="block text-sm font-semibold text-black mb-2">
              Select Export Format
            </label>
            <div className="md:flex md:flex-wrap lg:flex lg:flex-wrap grid grid-cols-2 space-x-4 md:space-x-16">
              {["Xls", "Csv", "Json", "Pdf"].map((format) => (
                <label
                  key={format}
                  className={`cursor-pointer flex items-center justify-between px-6 ml-4 py-2 border rounded-lg text-sm font-medium mb-2 md:mb-0 ${
                    exportFormat === format
                      ? "border-orange-500 text-orange-500"
                      : "border-gray-300 text-black"
                  }`}
                >
                  <input
                    type="radio"
                    name="exportFormat"
                    value={format}
                    checked={exportFormat === format}
                    onChange={() => setExportFormat(format)}
                    className="hidden"
                    required
                  />
                  <span>{format}</span>
                  <span
                    className={`ml-2 w-4 h-4 border-2 rounded-full flex items-center justify-center ${
                      exportFormat === format
                        ? "border-orange-500"
                        : "border-gray-300"
                    }`}
                  >
                    {exportFormat === format && (
                      <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                    )}
                  </span>
                </label>
              ))}
            </div>
          </div>

          {/* Export Button */}
          <div className="text-center">
            <button
              type="submit"
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-md text-sm font-medium"
            >
              Export
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ExportResumes;
